import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withFormTracking } from 'components/core/library/tracking-utils';

/**
 * Component used render a form.
 *
 * **Base CSS Class:** `ph-form`
 */

const enhance = withFormTracking;

export function CoreForm({ children, className, onSubmit, id}) {
	return (
		<form
			className={classnames('ph-form', className)}
			onSubmit={onSubmit}
			id={id}
		>
			{children}
		</form>
	);
}

CoreForm.propTypes = {
	children: PropTypes.node,
	onSubmit: PropTypes.func,
	className: PropTypes.string,
	id: PropTypes.string
};

export default enhance(CoreForm);
